import axios from 'axios'

const fetchUserPermissions = async ({ rootState, commit }) => {
  await axios.get(`${rootState.baseURL}/user/permissions`)
  .then((res) => {
    commit('setUserPermissions', res.data.data)
  })
}

export default {
  fetchUserPermissions,
}
